<template>
    <div>
    <b-modal
      id="housetypemodal"
      :title="formModal.title"
      @hidden="resetModal"
      @ok="handleSubmit"
      ok-title="Submit"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit" novalidate>

        <b-form-group label="Name" label-for="name-input">
            <b-form-input id="name-input" v-model="form.name" :state="validateState('name')"></b-form-input>
        </b-form-group>

        <b-form-group label="Context Helper" label-for="context_helper-input">
            <b-form-textarea id="context_helper-input" v-model="form.context_helper"></b-form-textarea>
        </b-form-group>

      </form>
    </b-modal>

    <b-modal
      id="housetypeimportmodal"
      title="Import House Types"
      @hidden="resetImport"
      :ok-disabled="importBusy"
      ok-title="Upload"
      @ok="handleImport"
    >
      <div class="mb-3">
        <a :href="route('admin.houses.types.import.template')" class="btn btn-outline-secondary btn-sm">
          <i class="fas fa-download mr-1"></i> Download Template
        </a>
        <small class="d-block text-muted mt-1">Fill the template then upload it below.</small>
      </div>

      <b-form-group label="Excel File (.xlsx / .xls / .csv)">
        <b-form-file v-model="importFile" accept=".xlsx,.xls,.csv" :disabled="importBusy"></b-form-file>
      </b-form-group>

      <div v-if="importStatus" class="mt-3">
        <div v-if="importStatus === 'pending' || importStatus === 'processing'" class="d-flex align-items-center text-primary">
          <b-spinner small class="mr-2"></b-spinner>
          Import in progress… ({{ importProcessed }} rows processed)
        </div>
        <div v-else-if="importStatus === 'completed'" class="text-success">
          <i class="fas fa-check-circle mr-1"></i> Import completed — {{ importProcessed }} rows added.
        </div>
        <div v-else-if="importStatus === 'failed'" class="text-danger">
          <i class="fas fa-times-circle mr-1"></i> Import failed: {{ importError }}
        </div>
      </div>
    </b-modal>
    </div>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
export default {
    data(){
        return this.initData();
    },
    mounted() {
        // this.openModal();
    },
    validations: {
        form: {
            name: { required }
        }
    },
    methods: {
        initData(){
            return {
                form:{
                    name: null,
                    context_helper: null
                },
                formModal:{
                    title: null
                },
                isEdit: false,
                language: 'en',
                importFile: null,
                importBusy: false,
                importStatus: null,
                importProcessed: 0,
                importError: null,
                importPollTimer: null,
            }
        },
        validateState(name) {
            const { $dirty, $error } = this.$v.form[name];
            return $dirty ? !$error : null;
        },
        openModal(){
            this.isEdit = false;
            this.formModal.title = "Add House Type";
            this.$bvModal.show('housetypemodal');
        },
        async editModal(id){
            this.isEdit = true;
            this.formModal.title = "Edit House Type";
            try {
                const { data } = await axios.get(route("admin.houses.types.showLang", [id, 'en']));
                this.form = data.data;
                this.$bvModal.show('housetypemodal');
            } catch (e) {
                console.log(e);
                this.$swal('Error!', '', 'error');
            }
            this.$bvModal.show('housetypemodal');
        },
        resetModal(){
            this.form = this.initData().form;
            this.$nextTick(() => {
                this.$v.$reset();
            });
        },
        handleSubmit(bvModalEvt){
            bvModalEvt.preventDefault();
            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
                return;
            }
            if(this.isEdit == true){
                this.submitUpdate();
            }else{
                this.submitSave();
            }
        },
        async submitSave(){
            try {
                const { data } = await axios.post(route("admin.houses.types.store"), {
                    form: this.form,
                    language: this.language
                });
                this.$swal('Saved!', '', 'success');
                this.$bvModal.hide('housetypemodal');
                reloadTable();
            } catch (e) {
                this.$swal('Error!', '', 'error');
            }
        },
        async submitUpdate(){
            try {
                const { data } = await axios.put(route("admin.houses.types.update", this.form.id), {
                    form: this.form,
                    language: this.language
                });
                this.$swal('Saved!', '', 'success');
                reloadTable();
            } catch (e) {
                console.log(e);
                this.$swal('Error!', '', 'error');
            }
        },
        async deleteUser(id){
             this.$swal({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const { data } = await axios.delete(route("admin.houses.types.destroy", id ));
                        this.$swal({
                            title: 'Deleted!',
                            text: 'House Type has been deleted.',
                            icon: 'success',
                            didClose: () =>{
                                reloadTable();
                            }
                        })
                    } catch (e) {
                        console.log(e);
                    }
                }
            });
        },
        openImportModal() {
            this.$bvModal.show('housetypeimportmodal');
        },
        resetImport() {
            clearInterval(this.importPollTimer);
            this.importFile = null;
            this.importBusy = false;
            this.importStatus = null;
            this.importProcessed = 0;
            this.importError = null;
            this.importPollTimer = null;
        },
        async handleImport(bvModalEvt) {
            bvModalEvt.preventDefault();
            if (!this.importFile) {
                this.$swal('Please select a file.', '', 'warning');
                return;
            }
            this.importBusy = true;
            this.importStatus = 'pending';
            const fd = new FormData();
            fd.append('file', this.importFile);
            try {
                const { data } = await axios.post(route('admin.houses.types.import'), fd);
                this.pollImportStatus(data.log_id);
            } catch (e) {
                this.importBusy = false;
                this.importStatus = 'failed';
                this.importError = e.response?.data?.message || 'Upload failed.';
            }
        },
        pollImportStatus(logId) {
            this.importPollTimer = setInterval(async () => {
                try {
                    const { data } = await axios.get(route('admin.import-logs.show', logId));
                    this.importStatus = data.status;
                    this.importProcessed = data.processed_rows;
                    if (data.status === 'completed') {
                        clearInterval(this.importPollTimer);
                        this.importBusy = false;
                        reloadTable();
                    } else if (data.status === 'failed') {
                        clearInterval(this.importPollTimer);
                        this.importBusy = false;
                        this.importError = data.error_message;
                    }
                } catch (e) {
                    clearInterval(this.importPollTimer);
                    this.importBusy = false;
                }
            }, 2000);
        }
    }
}

</script>
